import axios from 'axios';
const adminURL = process.env.VUE_APP_ADMIN_URL;

export default class ServiceTranslationsService {
  static getHeaders() {
    const token = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${token}` };
  }

  static async getLanguages() {
    try {
      const res = await axios.get(`${adminURL}/service-translations/languages`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) {
      return { status: 'error', message: e.response?.data?.message };
    }
  }

  static async getByService(serviceId) {
    try {
      const res = await axios.get(`${adminURL}/service-translations/${serviceId}`, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) {
      return { status: 'error', message: e.response?.data?.message };
    }
  }

  static async create(payload) {
    try {
      const res = await axios.post(`${adminURL}/service-translations`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) {
      return { status: 'error', message: e.response?.data?.message };
    }
  }

  static async update(id, payload) {
    try {
      const res = await axios.put(`${adminURL}/service-translations/${id}`, payload, {
        headers: this.getHeaders()
      });
      return { status: 'ok', data: res.data.data ?? res.data };
    } catch (e) {
      return { status: 'error', message: e.response?.data?.message };
    }
  }

  static async remove(id) {
    try {
      await axios.delete(`${adminURL}/service-translations/${id}`, {
        headers: this.getHeaders()
      });
      return { status: 'ok' };
    } catch (e) {
      return { status: 'error', message: e.response?.data?.message };
    }
  }
}
